import React from "react";

export default function H2withIcon(props) {
  return (
    <h1 className="font-medium lg:text-xl text-[#1466A2] flex items-center mb-4 underline underline-offset-2">
      {props.children}
    </h1>
  );
}
